import {Layout, Image, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const EducationTA = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX']}}>Transform Aging</Paragraph>
        <Text className='BaseText2'>The series of workshops <b><q>Let&apos;s Transform Aging</q></b> were created with the intention of <b>interacting with elders</b> and, through 3 different sessions, creating <b>spaces</b> for <b>dialogue, learning</b> and <b>activation</b>. From dancing to lectures, we centered on providing the participants with reliable information about the science of aging, how to stay active and our project.</Text>
        <Content style={{maxWidth: '70%', background: 'inherit', marginLeft: 'auto', marginRight: 'auto', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/education/eduposter.png'></Image>
        </Content>
        <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center', fontSize: '3.5vh'}}>If you want to learn about this project, visit the <a href='https://2022.igem.wiki/tecccm/human-practices'> <b>human practices</b></a> page.</Paragraph>
      </Content>
    </Layout>
  );
};

export default EducationTA;
